export enum AppActionType {
  UPDATE_CONTACT_FORM_DETAILS = "UPDATE_CONTACT_FORM_DETAILS",
  SET_SELECTED_CITY = "SET_SELECTED_CITY",
}
